import { render, staticRenderFns } from "./Materiais.vue?vue&type=template&id=2134bfb5&scoped=true&"
import script from "./Materiais.vue?vue&type=script&lang=js&"
export * from "./Materiais.vue?vue&type=script&lang=js&"
import style0 from "./Materiais.vue?vue&type=style&index=0&id=2134bfb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2134bfb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
